import { render, staticRenderFns } from "./jointOrderATransfer.vue?vue&type=template&id=27b6e8cd&scoped=true&"
import script from "./jointOrderATransfer.vue?vue&type=script&lang=js&"
export * from "./jointOrderATransfer.vue?vue&type=script&lang=js&"
import style0 from "./jointOrderATransfer.vue?vue&type=style&index=0&id=27b6e8cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b6e8cd",
  null
  
)

export default component.exports